var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field)?_c('div',{staticClass:"excuse-box",class:_vm.$safe(_vm.field,'DaySpecification.Color')}):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }